module.exports = __webpack_public_path__ + "static/media/pin_ambulancia.f9ee9e7b.png";